import React, { useState, useEffect } from 'react';
import axios from 'axios';

import './WifiManagement.css';

const WifiVerify = () => {
  useEffect(() => { document.title = 'Mi WIFI'; }, []);
  const [step, setStep] = useState('id'); // 'id' | 'name' | 'phone'
  const [clientId, setClientId] = useState('');
  const [last4, setLast4] = useState('');
  const [lookupData, setLookupData] = useState(null); // { name, maskedPhone, contactId }
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const resetToIdStep = () => {
    setStep('id');
    setClientId('');
    setLast4('');
    setLookupData(null);
    setError('');
  };

  const handleLookup = async (e) => {
    e.preventDefault();
    if (!clientId.trim()) return;
    setError('');
    setLoading(true);
    try {
      const res = await axios.post('/api/wifi/public/lookup', { clientId: clientId.trim() });
      if (res.data.success) {
        setLookupData(res.data);
        setStep('name');
      } else {
        setError(res.data.error || 'ID no encontrado');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Error al buscar el cliente');
    } finally {
      setLoading(false);
    }
  };

  const handleNameConfirmation = (isCorrectName) => {
    setError('');
    if (isCorrectName) {
      setStep('phone');
      return;
    }

    resetToIdStep();
  };

  const handleConfirm = async (e) => {
    e.preventDefault();
    if (last4.length !== 4) {
      setError('Ingresa los 4 digitos');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const res = await axios.post('/api/wifi/public/confirm', {
        contactId: lookupData.contactId,
        clientId,
        last4
      });
      if (res.data.success) {
        window.location.href = '/cliente/' + res.data.token;
      } else {
        setError(res.data.error || 'Los digitos no coinciden');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Error al verificar');
    } finally {
      setLoading(false);
    }
  };

  const cardStyle = {
    borderRadius: 16,
    padding: 32,
    background: '#fff',
    boxShadow: '0 4px 24px rgba(0,0,0,0.1)'
  };

  const phonePrefix = lookupData?.maskedPhone
    ? lookupData.maskedPhone.replace(/\*+/g, '').replace(/-$/, '')
    : '';
  const phonePrefixDisplay = phonePrefix ? `${phonePrefix}-` : '';

  const primaryButtonStyle = {
    width: '100%',
    padding: '13px',
    background: loading ? '#aaa' : '#0066cc',
    color: '#fff',
    border: 'none',
    borderRadius: 10,
    fontSize: 16,
    fontWeight: 700,
    cursor: loading ? 'not-allowed' : 'pointer'
  };

  const secondaryButtonStyle = {
    width: '100%',
    marginTop: 10,
    padding: '10px',
    background: 'transparent',
    color: '#666',
    border: '1.5px solid #ddd',
    borderRadius: 10,
    fontSize: 14,
    cursor: 'pointer'
  };

  return (
    <div className="wifi-management-container" style={{ maxWidth: 420, margin: '40px auto', padding: '0 16px' }}>
      <div className="wifi-card" style={cardStyle}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 48 }}>🔐</div>
          <h2 style={{ margin: '8px 0 4px', color: '#1a1a2e' }}>Gestion de WiFi</h2>
          <p style={{ color: '#666', fontSize: 14, margin: 0 }}>Verificacion de identidad</p>
        </div>

        {step === 'id' && (
          <form onSubmit={handleLookup}>
            <p style={{ color: '#444', marginBottom: 16, textAlign: 'center' }}>
              Ingresa tu numero de cliente para continuar
            </p>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontWeight: 600, marginBottom: 6, color: '#333' }}>
                Numero de cliente (ID)
              </label>
              <input
                type="text"
                value={clientId}
                onChange={(e) => setClientId(e.target.value)}
                placeholder="Ej: 513"
                style={{ width: '100%', padding: '12px 14px', borderRadius: 10, border: '1.5px solid #ddd', fontSize: 16, boxSizing: 'border-box' }}
                autoFocus
              />
            </div>
            {error && <p style={{ color: '#e53e3e', fontSize: 14, marginBottom: 12 }}>{error}</p>}
            <button type="submit" disabled={loading || !clientId.trim()} style={primaryButtonStyle}>
              {loading ? 'Buscando...' : 'Continuar ->'}
            </button>
          </form>
        )}

        {step === 'name' && lookupData && (
          <div>
            <p style={{ color: '#444', marginBottom: 10, textAlign: 'center', fontSize: 15 }}>
              Este es tu nombre?
            </p>
            <div style={{ background: '#f0f7ff', borderRadius: 14, padding: 18, marginBottom: 18, textAlign: 'center' }}>
              <p style={{ margin: '0 0 10px', color: '#666', fontSize: 13, textTransform: 'uppercase', letterSpacing: 1.2 }}>
                Cliente encontrado
              </p>
              <div style={{ fontWeight: 800, fontSize: 30, lineHeight: 1.15, color: '#103d7a', textTransform: 'uppercase' }}>
                {lookupData.name}
              </div>
            </div>
            {error && <p style={{ color: '#e53e3e', fontSize: 14, marginBottom: 12 }}>{error}</p>}
            <button type="button" onClick={() => handleNameConfirmation(true)} style={primaryButtonStyle}>
              SI
            </button>
            <button
              type="button"
              onClick={() => handleNameConfirmation(false)}
              style={{ ...secondaryButtonStyle, marginTop: 12, padding: '13px', fontSize: 16, fontWeight: 700 }}
            >
              NO
            </button>
          </div>
        )}

        {step === 'phone' && lookupData && (
          <form onSubmit={handleConfirm}>
            <div style={{ background: '#f0f7ff', borderRadius: 14, padding: 18, marginBottom: 18, textAlign: 'center' }}>
              <p style={{ margin: '0 0 10px', color: '#666', fontSize: 13, textTransform: 'uppercase', letterSpacing: 1.2 }}>
                Confirmacion de identidad
              </p>
              <div style={{ fontWeight: 800, fontSize: 26, lineHeight: 1.15, color: '#103d7a', textTransform: 'uppercase', marginBottom: 8 }}>
                {lookupData.name}
              </div>
              <p style={{ margin: 0, color: '#555', fontSize: 15 }}>
                Completa los <strong>ultimos 4 digitos</strong> de tu numero de telefono
              </p>
            </div>
            <div style={{ marginBottom: 16 }}>
              <div
                style={{
                  width: '100%',
                  borderRadius: 12,
                  border: '1.5px solid #ddd',
                  boxSizing: 'border-box',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexWrap: 'nowrap',
                  gap: 4,
                  padding: '16px 14px',
                  background: '#fff',
                  overflow: 'hidden'
                }}
              >
                <span style={{ fontSize: 28, fontWeight: 800, color: '#103d7a', letterSpacing: 1, whiteSpace: 'nowrap', flexShrink: 0 }}>
                  {phonePrefixDisplay}
                </span>
                <input
                  type="tel"
                  value={last4}
                  maxLength={4}
                  onChange={(e) => setLast4(e.target.value.replace(/\D/g, ''))}
                  placeholder="_ _ _ _"
                  style={{ width: 118, border: 'none', outline: 'none', fontSize: 28, fontWeight: 800, textAlign: 'left', letterSpacing: 6, boxSizing: 'border-box', background: 'transparent', color: '#111827', whiteSpace: 'nowrap', flexShrink: 0 }}
                  autoFocus
                />
              </div>
            </div>
            {lookupData.maskedPhone && (
              <p style={{ color: '#6b7280', textAlign: 'center', marginTop: '-4px', marginBottom: 14, fontSize: 14 }}>
                Completa los 4 digitos finales de tu telefono en el espacio en blanco
              </p>
            )}
            {error && <p style={{ color: '#e53e3e', fontSize: 14, marginBottom: 12 }}>{error}</p>}
            <button type="submit" disabled={loading || last4.length !== 4} style={primaryButtonStyle}>
              {loading ? 'Verificando...' : 'Verificar y entrar ->'}
            </button>
            <button
              type="button"
              onClick={() => { setStep('name'); setError(''); setLast4(''); }}
              style={secondaryButtonStyle}
            >
              Volver
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default WifiVerify;
